<template>
  <b-row class="align-items-baseline">
    <h4 class="d-inline-block font-weight-bold my-2">
      <slot />
    </h4>

    <slot name="extra" />
  </b-row>
</template>
